import EntityUpdateComponent, {
  EntityUpdateComponentProps,
} from './EntityUpdateComponent';

export default EntityUpdateComponent;

export type { EntityUpdateComponentProps };
